import TwoColumnLayOut from "../../../../layouts/two-columns/two-column-layout";
import AwardsComponent from "./components/index.component";

const Awards = () => {
  const path = "Who-We-Are%2FCelebrate-the-Profession%2FAwards";

  return (
    <>
      <TwoColumnLayOut breadcrumbPath={path} isBreadcrumbpath={true} showAds={true}>
        <AwardsComponent />
      </TwoColumnLayOut>
    </>
  );
};

export default Awards;
